import { render, staticRenderFns } from "./JSelectMaterialModal.vue?vue&type=template&id=23759c84&scoped=true"
import script from "./JSelectMaterialModal.vue?vue&type=script&lang=js"
export * from "./JSelectMaterialModal.vue?vue&type=script&lang=js"
import style0 from "./JSelectMaterialModal.vue?vue&type=style&index=0&id=23759c84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_css-loader@7.1.2_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23759c84",
  null
  
)

export default component.exports